import React, { useState } from 'react';
import './case-header.scss';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/config/store';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { ConfirmationModal } from 'app/shared/modal/confirmation-modal';
import { CaseAction } from '../cases.model';
import {
  doActionForCaseQuery,
  ICaseActionProps,
  validateTabsForActionQuery
} from 'app/edozvola/cases/service/cases.queries';
import { CaseState } from 'app/shared/reducers/case-entity';
import { fetchCaseById } from "app/edozvola/cases/cases-service";
import { shouldUserSeeCaseInAmendmentQuery } from 'app/edozvola/cases/header/service/case-header.queries';
import { useParams } from 'react-router-dom';

export interface ICaseHeaderProps {
  caseHeaderData?: CaseState
}

const CaseHeader = (props: ICaseHeaderProps) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [confirmActionModalShown, setConfirmActionModalShown] = useState<boolean>(false);
  const [selectedAction, setSelectedAction] = useState<CaseAction>();

  const selectedCase = props.caseHeaderData ? props.caseHeaderData : useSelector((state: IRootState) => state.caseEntity);

  const { data: caseInAmendment, isLoading } = shouldUserSeeCaseInAmendmentQuery(uuid);

  const isDeleteAction = () => {
    if (selectedAction) {
      const deleteActionKeys = ['IZBRISI_ZAHTJEV', 'IZBRISI_PREDMET'];
      return deleteActionKeys.includes(selectedAction.key);
    }
    return false;
  }
  const isSubmitRequestAction = (element: CaseAction) => {
    const submitRequestKeys = ['PREDAJ_ZAHTJEV_NEPRIJAVLJENI', 'PREDAJ_ZAHTJEV_EGRADJANIN'];
    return submitRequestKeys.includes(element.key);
  }

  const isSubmitAmendmentAction = (element: CaseAction) => {
    const submitRequestKeys = ['PREDAJ_DOPUNU'];
    return submitRequestKeys.includes(element.key);
  }

  const checkActionPrerequisites = (element: CaseAction) => {
    setSelectedAction(element);
    validateTabsForAction({
      idCase: selectedCase.idCase,
      caseActionKey: element.key,
      successMessage: element.successMessage,
      errorMessage: element.errorMessage,
    } as ICaseActionProps);
  };

  const { mutate: doActionForCaseMutation, isPending: isActionPending } = doActionForCaseQuery(() => setConfirmActionModalShown(false));
  const { mutate: validateTabsForAction } = validateTabsForActionQuery(() => {
    fetchCaseById(selectedCase.idCase).then(x => {
      x.caseActions.forEach(action => {
        if (action.key === selectedAction.key) {
          setSelectedAction(action);      // Reload confirmation message before opening modal
        }
      })
    }).then(() => setConfirmActionModalShown(true));
  });

  const renderActionsForCase = (index: number, element: CaseAction) => {
    if (isSubmitRequestAction(element)) {
      return (
        <div key={index} className="order-2 ms-auto d-flex align-items-center">
          <span className="fw-bold text-danger me-2">Ovaj zahtjev nije predan nadležnom uredu.</span>
          <Button
            color={element.forwardAction ? 'info' : 'danger'}
            className="ms-2"
            onClick={() => checkActionPrerequisites(element)}
            size={'lg'}
            label={element.value}
          />
        </div>
      );
    }
    else if (isSubmitAmendmentAction(element)) {
      return (
        <div key={index} className="order-2 ms-auto d-flex align-items-center">
          <span className="fw-bold text-danger me-2">Ova dopuna nije predana nadležnom uredu.</span>
          <Button
            color={element.forwardAction ? 'info' : 'danger'}
            className="ms-2"
            onClick={() => checkActionPrerequisites(element)}
            size={'lg'}
            label={element.value}
          />
        </div>
      );
    }

    return (
      <div key={index} className={element.forwardAction ? 'order-2 ms-auto' : 'order-1'}>
        <Button
          color={element.forwardAction ? 'info' : 'danger'}
          className={element.forwardAction ? 'ms-2' : 'me-2'}
          onClick={() => checkActionPrerequisites(element)}
          size={'lg'}
          label={element.value}
        />
      </div>
    );
  };

  return (
    <div id="case-header-wrapper">
      <Row>
        <Col xs={10}>
          <span className="case-header-column">

            <h3 className="fw-bold">{`${caseInAmendment ? 'Dopuna zahtjeva: ' : 'Predaja zahtjeva: '}${selectedCase?.caseCategory}`}</h3>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={10}>
          <span className="case-header-column">
            <span className="case-header-label">Šifra:</span>
            <span className="case-header-text">{selectedCase?.webId}</span>
          </span>
          <span className="case-header-column">
            <span className="case-header-label">Status zahtjeva:</span>
            <span className="case-header-text">{selectedCase?.caseStatus}</span>
          </span>
        </Col>
      </Row>
      {!props.caseHeaderData &&
        <Row className={'d-inline'}>
          <Col xs={12} className="d-flex align-items-center">{selectedCase?.caseActions?.map((element, index) => renderActionsForCase(index, element))}</Col>
        </Row>
      }
      <hr className="mt-0 mb-4" style={{ height: '2px', backgroundColor: 'black' }} />
      <ConfirmationModal
        header={selectedAction?.confirmationTitle ? selectedAction?.confirmationTitle : 'Potvrda'}
        modalOpened={confirmActionModalShown}
        bodyMessage={selectedAction?.confirmationText ? selectedAction?.confirmationText : 'Jeste li sigurni da želite potvrditi akciju?'}
        confirmButtonLabel={isDeleteAction() ? 'Obriši' : 'Potvrdi'}
        cancelButtonLabel={'Odustani'}
        deleteAction={isDeleteAction()}
        onConfirm={() =>
          doActionForCaseMutation({
            idCase: selectedCase.idCase,
            caseActionKey: selectedAction?.key,
            successMessage: selectedAction?.successMessage,
            errorMessage: selectedAction?.errorMessage,
          } as ICaseActionProps)
        }
        loadingStateForConfirmationButton={isActionPending}
        onCancel={() => setConfirmActionModalShown(false)}
      />
    </div>
  );
};

export default CaseHeader;
